// src/client/widget-loader.js
(function() {
    // Create a function to load the tee sheet booking widget
    function loadTeeSheetWidget(widgetId) {

        if (window.eagleEyeTeeSheetWidgetInitialized === true){
            console.error('Tee Sheet widget already initialized. Please only inject the initialization script once.');
            return;
        }

        // Clean up any existing stale data checks from previous widget instances
        if (window.cleanupTeeSheetWidget) {
            window.cleanupTeeSheetWidget();
        }

        // Use the base URL injected by Webpack; defaults to localhost if not overridden.
        const baseUrl = EAGLEEYE_WIDGET_BASE_URL;
        const TRACKING_SURFACE = 'widget_tee_sheet_booking';

        const ensureScriptOnce = (id, src) => new Promise((resolve) => {
            try {
                if (document.getElementById(id)) return resolve();
                const s = document.createElement('script');
                s.id = id;
                s.async = true;
                s.src = src;
                s.onload = () => resolve();
                s.onerror = () => resolve();
                document.head.appendChild(s);
            } catch (_) { resolve(); }
        });

        const getOrCreateId = (storage, key) => {
            try {
                const existing = storage.getItem(key);
                if (existing) return existing;
                const id = (window.crypto && window.crypto.randomUUID) ? window.crypto.randomUUID() : ('ee_' + Math.random().toString(36).slice(2) + Date.now().toString(36));
                storage.setItem(key, id);
                return id;
            } catch (_) { return ('ee_' + Math.random().toString(36).slice(2) + Date.now().toString(36)); }
        };

        const safeSessionStorageGet = (key) => {
            try { return window.sessionStorage.getItem(key); } catch (_) { return null; }
        };
        const safeSessionStorageSet = (key, value) => {
            try { window.sessionStorage.setItem(key, value); } catch (_) {}
        };

        const getOrCreateSessionId = (tracker) => {
            const policy = tracker?._eagleEyeSessionPolicy || 'TabLifetime';
            const ttlMinutesRaw = tracker?._eagleEyeSessionTtlMinutes;
            const ttlMinutes = (ttlMinutesRaw == null) ? null : Number(ttlMinutesRaw);
            const now = Date.now();
            const sessionIdKey = 'ee_session_id';
            const sessionMetaKey = 'ee_session_meta';

            if (policy === 'PageLoad') {
                if (!tracker._pageLoadSessionId) {
                    tracker._pageLoadSessionId = (window.crypto && window.crypto.randomUUID)
                        ? window.crypto.randomUUID()
                        : ('ee_' + Math.random().toString(36).slice(2) + Date.now().toString(36));
                }
                safeSessionStorageSet(sessionIdKey, tracker._pageLoadSessionId);
                return tracker._pageLoadSessionId;
            }

            if (policy === 'TabLifetime') {
                const existing = safeSessionStorageGet(sessionIdKey);
                if (existing) return existing;
                return getOrCreateId(window.sessionStorage, sessionIdKey);
            }

            const ttlMs = (ttlMinutes != null && !Number.isNaN(ttlMinutes)) ? Math.max(1, ttlMinutes) * 60 * 1000 : null;
            let meta = null;
            try {
                const raw = safeSessionStorageGet(sessionMetaKey);
                meta = raw ? JSON.parse(raw) : null;
            } catch (_) { meta = null; }

            const currentId = (meta && typeof meta.id === 'string') ? meta.id : null;
            const createdUtcMs = (meta && typeof meta.createdUtcMs === 'number') ? meta.createdUtcMs : null;
            const lastSeenUtcMs = (meta && typeof meta.lastSeenUtcMs === 'number') ? meta.lastSeenUtcMs : null;

            const shouldRotate = ttlMs != null && (
                (policy === 'IdleTimeoutMinutes' && lastSeenUtcMs != null && (now - lastSeenUtcMs) > ttlMs) ||
                (policy === 'AbsoluteTimeoutMinutes' && createdUtcMs != null && (now - createdUtcMs) > ttlMs)
            );

            const id = (!currentId || shouldRotate) ? ((window.crypto && window.crypto.randomUUID) ? window.crypto.randomUUID() : ('ee_' + Math.random().toString(36).slice(2) + Date.now().toString(36))) : currentId;
            const nextMeta = {
                id,
                createdUtcMs: (!currentId || shouldRotate) ? now : (createdUtcMs || now),
                lastSeenUtcMs: now
            };
            try { safeSessionStorageSet(sessionMetaKey, JSON.stringify(nextMeta)); } catch (_) {}
            return id;
        };

        const resolveMapping = (mappings, provider, internalEvent) => {
            const list = mappings || [];
            for (let i = 0; i < list.length; i++) {
                const m = list[i];
                if ((m.provider || '') === provider && (m.internalEvent || '').trim() === (internalEvent || '').trim()) return m;
            }
            return null;
        };

        const defaultMetaEvent = (internalEvent) => {
            const e = (internalEvent || '').toLowerCase();
            if (e === 'page_view') return 'PageView';
            if (e === 'begin_checkout') return 'InitiateCheckout';
            if (e === 'add_payment_info') return 'AddPaymentInfo';
            if (e === 'purchase') return 'Purchase';
            return 'CustomEvent';
        };

        const ensureMetaPixelBootstrap = () => {
            if (window.fbq) return;
            (function(f,b,e,v,n,t,s){
                if (f.fbq) return;
                n = f.fbq = function(){ n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
                if (!f._fbq) f._fbq = n;
                n.push = n; n.loaded = true; n.version = '2.0'; n.queue = [];
                t = b.createElement(e); t.async = true; t.src = v;
                s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
            })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
        };

        const ensureGtagBootstrap = () => {
            window.dataLayer = window.dataLayer || [];
            if (typeof window.gtag === 'function') return;
            window.gtag = function() { window.dataLayer.push(arguments); };
            window.gtag('js', new Date());
        };

        const initTeeSheetTracking = (venueId) => {
            if (window.eeTeeSheetWidgetTracking && window.eeTeeSheetWidgetTracking._venueId === venueId) return window.eeTeeSheetWidgetTracking._readyPromise || Promise.resolve();
            const tracker = window.eeTeeSheetWidgetTracking || {};
            tracker._venueId = venueId;
            tracker._baseUrl = baseUrl;
            tracker._providers = [];
            tracker._mappings = [];
            tracker._eagleEyeEnabled = false;
            tracker._readyPromise = fetch(`${baseUrl}/pixel-settings?venueId=${encodeURIComponent(venueId)}`)
                .then(r => r.json())
                .then(cfg => {
                    tracker._providers = cfg?.providers || [];
                    tracker._mappings = cfg?.eventMappings || [];
                    tracker._eagleEyeEnabled = !!cfg?.eagleEyeEnabled;
                    tracker._eagleEyeSessionPolicy = cfg?.eagleEyeSessionPolicy || 'TabLifetime';
                    tracker._eagleEyeSessionTtlMinutes = cfg?.eagleEyeSessionTtlMinutes ?? null;

                    const ga4 = tracker._providers.find(p => p.provider === 'GA4' && p.clientId);
                    const ads = tracker._providers.find(p => p.provider === 'GoogleAds' && p.clientId);
                    const firstId = (ga4?.clientId || ads?.clientId);
                    if (firstId) {
                        return ensureScriptOnce('ee-tee-gtag', `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(firstId)}`)
                            .then(() => {
                                ensureGtagBootstrap();
                                if (ga4?.clientId) window.gtag('config', ga4.clientId);
                                if (ads?.clientId) window.gtag('config', ads.clientId);
                            });
                    }
                })
                .catch(() => {});

            tracker.track = (eventName, payload) => {
                try {
                    const skipThirdParty = !!(payload && payload.skipThirdParty === true);
                    const visitorId = getOrCreateId(window.localStorage, 'ee_visitor_id');
                    const sessionId = getOrCreateSessionId(tracker);
                    const eventId = (window.crypto && window.crypto.randomUUID) ? window.crypto.randomUUID() : ('ee_' + Math.random().toString(36).slice(2));

                    const sourceId = payload?.sourceId ?? venueId;
                    const sourceIdType = payload?.sourceIdType ?? (payload?.sourceId ? 'Other' : 'VenueId');
                    const body = {
                        corporationDetailId: venueId,
                        eventName,
                        surface: TRACKING_SURFACE,
                        visitorId,
                        sessionId,
                        eventId,
                        url: window.location.href,
                        referrer: document.referrer || null,
                        // Sent from the browser so the visitor's device survives the widget
                        // server hop, which strips it otherwise (EAG-1202).
                        userAgent: (navigator && navigator.userAgent) || null,
                        value: payload?.valueCents ?? null,
                        currency: payload?.currency ?? null,
                        sourceId: sourceId,
                        sourceIdType: sourceIdType,
                        secondarySourceId: venueId,
                        secondarySourceIdType: 'VenueId',
                        email: payload?.email ?? null,
                        phoneNumber: payload?.phoneNumber ?? null,
                        properties: payload?.properties ?? null
                    };

                    if (tracker._eagleEyeEnabled === true) {
                        fetch(`${baseUrl}/tracking/event`, {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json', 'X-Widget-Origin': window.location.origin },
                            body: JSON.stringify(body),
                            keepalive: true
                        }).catch(() => {});
                    }

                    if (skipThirdParty) {
                        return;
                    }

                    const meta = tracker._providers.find(p => p.provider === 'Meta' && p.clientId);
                    if (meta?.clientId) {
                        ensureMetaPixelBootstrap();
                        window.fbq('init', meta.clientId);
                        const m = resolveMapping(tracker._mappings, 'Meta', eventName);
                        const metaEvent = (m?.providerEventName || '').trim() || defaultMetaEvent(eventName);
                        const metaParams = {};
                        if (payload?.valueCents != null) metaParams.value = payload.valueCents / 100;
                        if (payload?.currency) metaParams.currency = payload.currency;
                        window.fbq('track', metaEvent, metaParams, { eventID: eventId });
                    }

                    // Google (GA4 + Google Ads)
                    const ga4p = tracker._providers.find(p => p.provider === 'GA4' && p.clientId);
                    const adsp = tracker._providers.find(p => p.provider === 'GoogleAds' && p.clientId);
                    if (ga4p?.clientId || adsp?.clientId) {
                        ensureGtagBootstrap();
                        const gParams = {};
                        if (payload?.valueCents != null) gParams.value = payload.valueCents / 100;
                        if (payload?.currency) gParams.currency = payload.currency;

                        if (ga4p?.clientId) {
                            const g = resolveMapping(tracker._mappings, 'GA4', eventName);
                            const ga4Event = (g?.providerEventName || '').trim() || eventName;
                            window.gtag('event', ga4Event, Object.assign({ send_to: ga4p.clientId }, gParams));
                        }

                        if (adsp?.clientId) {
                            const a = resolveMapping(tracker._mappings, 'GoogleAds', eventName);
                            const label = (a?.providerConversionId || '').trim();
                            if (label) {
                                const sendTo = label.indexOf('/') >= 0 ? label : (adsp.clientId + '/' + label);
                                const txnId = (sourceId && sourceIdType !== 'VenueId') ? sourceId : eventId;
                                window.gtag('event', 'conversion', Object.assign({ send_to: sendTo, transaction_id: txnId }, gParams));
                            }
                        }
                    }
                } catch (_) {}
            };

            window.eeTeeSheetWidgetTracking = tracker;
            return tracker._readyPromise || Promise.resolve();
        };
        
        // Fetch the widget HTML content and data from the server
        fetch(`${baseUrl}/tee-sheet-widget?widgetId=${widgetId}`)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Widget configuration not found (${response.status})`);
                }
                return response.text();
            })
            .then(htmlContent => {
                // Create a container to parse the HTML content
                var container = document.createElement('div');
                container.innerHTML = htmlContent;

                // Extract and execute scripts
                var scripts = container.querySelectorAll('script');
                scripts.forEach(function(script) {
                    if (script.src) {
                        // External script
                        var newScript = document.createElement('script');
                        newScript.src = script.src;
                        newScript.crossOrigin = script.crossOrigin || null;
                        document.head.appendChild(newScript);
                    } else {
                        // Inline script
                        try {
                            eval(script.textContent);
                        } catch (e) {
                            console.error('Error executing widget script:', e);
                        }
                    }
                    // Remove script from container
                    script.parentNode.removeChild(script);
                });

                // Append the rest of the HTML content to the body or target container
                var targetContainer = document.getElementById('tee-sheet-widget-container');
                if (targetContainer) {
                    while (container.firstChild) {
                        targetContainer.appendChild(container.firstChild);
                    }
                } else {
                    // If no specific container, append to body
                    while (container.firstChild) {
                        document.body.appendChild(container.firstChild);
                    }
                }

                // Initialize pixels/tracking (venueId is in WIDGET_CONFIG)
                try {
                    const venueId = window.WIDGET_CONFIG && (window.WIDGET_CONFIG.corporationDetailId || window.WIDGET_CONFIG.corporationDetailID);
                    if (venueId) {
                        initTeeSheetTracking(String(venueId)).then(() => {
                            if (window.eeTeeSheetWidgetTracking && typeof window.eeTeeSheetWidgetTracking.track === 'function') {
                                window.eeTeeSheetWidgetTracking.track('widget_loaded', { sourceId: String(widgetId), skipThirdParty: true, properties: { widget: 'tee_sheet', widgetId: String(widgetId), mode: 'modal' } });
                                window.eeTeeSheetWidgetTracking.track('page_view', { sourceId: String(widgetId), properties: { widget: 'tee_sheet', widgetId: String(widgetId) } });
                            }
                        });
                    }
                } catch (_) { /* ignore */ }

                // Load dependencies
                loadDependencies(baseUrl);
            })
            .catch(error => {
                console.error('Error loading tee sheet widget:', error);
                showWidgetError(error.message);
            });

            window.eagleEyeTeeSheetWidgetInitialized = true;
    }

    function loadDependencies(baseUrl) {
        // Load Luxon library for date handling
        if (!window.luxon) {
            var luxonScript = document.createElement('script');
            luxonScript.src = 'https://cdn.jsdelivr.net/npm/luxon@3.0.0/build/global/luxon.min.js';
            luxonScript.onload = function() {
                console.log('Luxon loaded');
                loadFlatpickr(baseUrl);
            };
            luxonScript.onerror = function() {
                window.__eeCdnErrors = window.__eeCdnErrors || [];
                window.__eeCdnErrors.push({ library: 'luxon', url: luxonScript.src, timestamp: new Date().toISOString() });
                console.error('Failed to load Luxon');
                loadFlatpickr(baseUrl); // Continue anyway
            };
            document.head.appendChild(luxonScript);
        } else {
            loadFlatpickr(baseUrl);
        }
    }

    function loadFlatpickr(baseUrl) {
        // Load Flatpickr CSS
        if (!document.getElementById('flatpickr-css')) {
            var flatpickrCSS = document.createElement('link');
            flatpickrCSS.id = 'flatpickr-css';
            flatpickrCSS.rel = 'stylesheet';
            flatpickrCSS.href = 'https://cdn.jsdelivr.net/npm/flatpickr/dist/flatpickr.min.css';
            document.head.appendChild(flatpickrCSS);
        }

        // Load Flatpickr JS
        if (!window.flatpickr) {
            var flatpickrScript = document.createElement('script');
            flatpickrScript.src = 'https://cdn.jsdelivr.net/npm/flatpickr';
            flatpickrScript.onload = function() {
                console.log('Flatpickr loaded');
                loadStripe(baseUrl);
            };
            flatpickrScript.onerror = function() {
                window.__eeCdnErrors = window.__eeCdnErrors || [];
                window.__eeCdnErrors.push({ library: 'flatpickr', url: flatpickrScript.src, timestamp: new Date().toISOString() });
                console.error('Failed to load Flatpickr');
                loadStripe(baseUrl); // Continue anyway
            };
            document.head.appendChild(flatpickrScript);
        } else {
            loadStripe(baseUrl);
        }
    }

    function loadStripe(baseUrl) {
        // Load Stripe.js
        if (!window.Stripe) {
            var stripeScript = document.createElement('script');
            stripeScript.src = 'https://js.stripe.com/v3/';
            stripeScript.onload = function() {
                console.log('Stripe.js loaded');
                loadMainWidget(baseUrl);
            };
            stripeScript.onerror = function() {
                window.__eeCdnErrors = window.__eeCdnErrors || [];
                window.__eeCdnErrors.push({ library: 'stripe', url: stripeScript.src, timestamp: new Date().toISOString() });
                console.error('Failed to load Stripe.js');
                loadMainWidget(baseUrl); // Continue anyway
            };
            document.head.appendChild(stripeScript);
        } else {
            loadMainWidget(baseUrl);
        }
    }

    function loadMainWidget(baseUrl) {
        // Load the main widget script with cache busting
        var script = document.createElement('script');
        var timestamp = new Date().getTime();
        script.src = `${baseUrl}/public/js/main.bundle.js?v=${timestamp}`;
        script.onload = function() {
            console.log('Tee Sheet widget script loaded');
            // Initialize the widget after the script is loaded
            if (window.initializeTeeSheetWidget) {
                window.initializeTeeSheetWidget();
            }
        };
        script.onerror = function() {
            console.error('Failed to load tee sheet widget script');
            showWidgetError('Failed to load widget. Please try refreshing the page.');
        };
        document.body.appendChild(script);
    }

    function showWidgetError(message) {
        var targetContainer = document.getElementById('tee-sheet-widget-container');
        if (targetContainer) {
            targetContainer.innerHTML = `
                <div style="padding: 40px; text-align: center; background: #fee; border: 2px solid #fcc; border-radius: 8px;">
                    <h2 style="color: #c00; margin-top: 0;">Widget Loading Error</h2>
                    <p style="color: #666;">${message}</p>
                    <button onclick="location.reload()" style="padding: 10px 20px; background: #c00; color: white; border: none; border-radius: 4px; cursor: pointer;">
                        Reload Page
                    </button>
                </div>
            `;
        }
    }

    // Expose the loadTeeSheetWidget function globally
    window.loadTeeSheetWidget = loadTeeSheetWidget;
})();



